(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lunea-ship-progress"] && !Shopify.designMode) return;
  try {
    (function () {
    // Секция корзины приходит заново (lunea-cart.liquid, swap) — новая линия сразу стоит
    // на новом значении. Ставим её на прежнее и отпускаем: CSS-переход дотягивает.
    // При prefers-reduced-motion перехода нет, линия просто встаёт на место.
    var last = null;
    function read() {
      var el = document.querySelector('[data-cart] [data-ship]');
      return el ? Number(el.getAttribute('data-ship')) : null;
    }
    function rendered() {
      var el = document.querySelector('[data-cart] [data-ship]');
      var fill = el && el.querySelector('.ship__fill');
      var next = el ? Number(el.getAttribute('data-ship')) : null;
      if (fill && last !== null && last !== next) {
        fill.style.setProperty('--ship', last);
        void fill.offsetWidth;
        fill.style.setProperty('--ship', next);
      }
      last = next;
    }
    document.addEventListener('lunea:cart-rendered', rendered);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { last = read(); });
    else last = read();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lunea-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    var dlg = document.querySelector('[data-signup]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var KEY = 'lunea:signup';
    var QUIET_DAYS = 14;

    function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function save(state) { try { localStorage.setItem(KEY, JSON.stringify({ s: state, t: Date.now() })); } catch (e) {} }

    // Только что подписались обычной отправкой формы (здесь или в футере) — больше не зовём.
    var posted = document.querySelector('[data-signup-posted]') || /[?&]customer_posted=true/.test(location.search);
    if (posted) save('joined');

    var form = dlg.querySelector('[data-signup-form]');
    var err = dlg.querySelector('[data-signup-error]');

    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-signup-close]') || e.target === dlg) close();
    });

    // Клавиатура iPhone: visualViewport — реально видимая часть экрана. Пока окно открыто,
    // держим шторку на её нижнем краю (--kb) и не выше видимой высоты (--vvh). Safari сам
    // сдвигает видимую область к полю (offsetTop) — это тоже учитываем. Страницу под окном
    // держит lunea-scroll-lock.
    var vv = window.visualViewport;
    function fit() {
      if (!vv) return;
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      dlg.style.setProperty('--kb', kb + 'px');
      dlg.style.setProperty('--vvh', Math.round(vv.height) + 'px');
      if (kb > 40) dlg.setAttribute('data-kb', ''); else dlg.removeAttribute('data-kb');
    }
    function track(on) {
      if (!vv) return;
      var m = on ? 'addEventListener' : 'removeEventListener';
      vv[m]('resize', fit); vv[m]('scroll', fit);
      if (on) fit(); else { dlg.style.removeProperty('--kb'); dlg.style.removeProperty('--vvh'); dlg.removeAttribute('data-kb'); }
    }
    // Поле в фокусе: после того как клавиатура встала, ещё раз подгоняем — iOS сообщает
    // итоговую высоту с задержкой.
    dlg.addEventListener('focusin', function () { setTimeout(fit, 300); });

    // Тап по коду — копируем; подпись «Tap to copy» → «Copied». Без clipboard API (старые
    // браузеры, не https) — выделяем код, чтобы скопировать вручную.
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-signup-copy]');
      if (!b) return;
      var code = b.getAttribute('data-signup-copy');
      var note = b.querySelector('[data-signup-copy-note]');
      function done() { if (note) note.textContent = note.getAttribute('data-copied'); }
      function pick() { var r = document.createRange(); r.selectNodeContents(b.querySelector('strong')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, pick);
      else pick();
    });

    dlg.addEventListener('close', function () {
      track(false);
      if (sending) return; // закрыли сами на время отправки — это не «отказ»
      var st = read();
      if (!st || st.s !== 'joined') save('closed');
    });

    function open() {
      if (dlg.open || document.querySelector('dialog[open]') || document.querySelector('[data-mobile-menu][open]')) return false;
      dlg.showModal();
      // Фокус — на само окно, а не на крестик: без рамки фокуса на касании; Tab ведёт дальше.
      dlg.focus();
      track(true);
      return true;
    }

    // Отправка — обычная, без fetch: защита Shopify от ботов (hCaptcha/Cloudflare) сама
    // дописывает в форму токен в момент отправки, а fetch в обход давал 400 (проверено на
    // luneastudioshop.com 05.10.2026). Shopify возвращает на ту же страницу с
    // ?customer_posted=true#lunea-signup — окно открывается само и показывает результат.
    // Окно закрываем: модальный dialog делает всю страницу «немой», и если Shopify покажет
    // покупателю капчу (hCaptcha — проверено, она появляется поверх страницы), её нельзя
    // было бы нажать. После успешной отправки страница вернётся с #lunea-signup и окно
    // откроется уже с «You're on the list».
    var sending = false;
    form.addEventListener('submit', function () {
      sending = true;
      var btn = form.querySelector('[type="submit"]');
      if (btn) setTimeout(function () { btn.disabled = true; }, 0); // без двойной отправки
      setTimeout(close, 0);
    });

    // Вернулись после отправки ИМЕННО этой формы (якорь #lunea-signup) — показываем итог.
    // Ошибка футерной формы окно не открывает: у неё другой якорь.
    if (location.hash === '#lunea-signup') {
      if (dlg.querySelector('[data-signup-step="done"]:not([hidden])')) { save('joined'); open(); return; }
      if (err && !err.hidden) { open(); return; }
    }

    var st = read();
    if (st && (st.s === 'joined' || (st.s === 'closed' && Date.now() - st.t < QUIET_DAYS * 864e5))) return;

    function arm(test) {
      var done = false;
      function check() {
        if (done || !test()) return;
        done = true;
        window.removeEventListener('scroll', onScroll);
        setTimeout(function () { if (!open()) { done = false; window.addEventListener('scroll', onScroll, { passive: true }); } }, 500);
      }
      function onScroll() { requestAnimationFrame(check); }
      window.addEventListener('scroll', onScroll, { passive: true });
      check();
    }

    var hero = document.querySelector('[data-hero]');
    if (hero) arm(function () { return hero.getBoundingClientRect().bottom < 0; });
    else arm(function () { return window.scrollY > window.innerHeight * 2; });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lunea-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('[data-to-top]');
    if (!btn) return;
    btn.hidden = false;
    var on = null;
    var ticking = false;
    function update() {
      ticking = false;
      var show = window.scrollY > window.innerHeight * 0.8;
      if (show === on) return;
      on = show;
      btn.classList.toggle('is-on', on);
      btn.inert = !on; // невидимая кнопка не ловит ни касание, ни Tab
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      btn.blur();
    });
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lunea-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    // Запрос и подмену секции делает корзина (window.luneaCart в lunea-cart.liquid) — одна
    // очередь с − / + и видео сборки. Слушатели — делегированием: секция подменяется целиком.
    var adding = false;
    var added = '';
    var live = null;

    function say(text) {
      if (!live) {
        live = document.createElement('p');
        live.className = 'visually-hidden';
        live.setAttribute('role', 'status');
        document.body.appendChild(live);
      }
      live.textContent = '';
      setTimeout(function () { live.textContent = text; }, 50);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-upsell-form]') || !window.luneaCart) return; // без JS-корзины — обычной формой
      var id = Number(new FormData(form).get('id'));
      if (!id) return;
      e.preventDefault();
      var block = document.querySelector('[data-upsell]');
      adding = true;
      added = (block && block.getAttribute('data-added')) || '';
      window.luneaCart.run('cart/add.js', { items: [{ id: id, quantity: 1 }] });
    });

    // Добавленный товар из списка ушёл вместе со своей кнопкой — фокус на первую
    // оставшуюся «Add», чтобы с клавиатуры не выпадать в начало страницы.
    document.addEventListener('lunea:cart-rendered', function () {
      if (!adding) return;
      adding = false;
      var a = document.activeElement;
      if (!a || a === document.body) {
        var next = document.querySelector('[data-cart] [data-up-add]');
        if (next) next.focus({ preventScroll: true });
      }
      if (added) say(added);
    });

    // Цена в строке — выбранного варианта
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-up-variant]')) return;
      var o = t.options[t.selectedIndex];
      var price = t.closest('.up__row').querySelector('[data-up-price]');
      if (o && price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lunea-video-addon"] && !Shopify.designMode) return;
  try {
    (function () {
    // Видео сборки заказа в корзине. Запросы и подмену секции делает корзина
    // (window.luneaCart в lunea-cart.liquid) — одна очередь с − / + и Remove.
    // Слушатели — делегированием на document: секция подменяется целиком.
    var lastSync = '';

    function meta() { return document.querySelector('[data-video-cart]'); }
    // Порядок JS-блоков тем в общем файле Shopify не гарантирован: скрипт корзины
    // (window.luneaCart) мог ещё не выполниться — ждём один тик, а не перезагружаем сразу.
    // Перезагрузка — не чаще раза в 10 секунд, иначе видео без боксов уводило корзину
    // в бесконечную перезагрузку (баг-хантинг 05.10.2026).
    function run(url, body) {
      if (window.luneaCart) { window.luneaCart.run(url, body); return; }
      setTimeout(function () {
        if (window.luneaCart) { window.luneaCart.run(url, body); return; }
        try {
          var t = Number(sessionStorage.getItem('lunea:cart-reload') || 0);
          if (Date.now() - t < 10000) return;
          sessionStorage.setItem('lunea:cart-reload', String(Date.now()));
        } catch (err) {}
        location.reload();
      }, 0);
    }

    // Liquid отдаёт в data-sync пары "ключ":количество без фигурных скобок (литерал скобки
    // в выводе Liquid ломает парсер) — видео без боксов и лишние строки видео.
    // Одно и то же значение отправляем один раз, чтобы не зациклиться.
    function sync() {
      var m = meta();
      var s = m && m.dataset.sync;
      if (!s || s === lastSync) return;
      lastSync = s;
      try { run('cart/update.js', { updates: JSON.parse('{' + s + '}') }); } catch (e) {}
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-video-form]')) return;
      var btn = e.submitter;
      var v = btn && btn.closest('[data-video]');
      if (!v || !window.luneaCart) return; // без данных — уходит обычной формой
      e.preventDefault();
      var d = v.dataset;
      btn.setAttribute('aria-checked', d.videoKey ? 'false' : 'true');
      if (d.videoKey) {
        run('cart/change.js', { id: d.videoKey, quantity: 0 });
      } else {
        run('cart/add.js', { items: [{
          id: Number(d.variant), quantity: 1, properties: { 'Share on socials': 'No' }
        }] });
      }
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-video-share]')) return;
      var d = t.closest('[data-video]').dataset;
      run('cart/change.js', {
        id: d.videoKey, quantity: 1, properties: { 'Share on socials': t.checked ? 'Yes' : 'No' }
      });
    });

    // Email получателя видео: сохраняем в атрибут корзины, когда человек закончил ввод
    // (change = ушёл из поля). Без перерисовки корзины — фокус и клавиатура остаются на месте.
    // Если сразу жмут «Check out», поле уйдёт с формой корзины (form="cart-form").
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-video-to]')) return;
      var v = t.value.trim();
      if (v && !t.checkValidity()) return; // браузер сам подсветит неверный адрес
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Video recipient email': v } })
      }).catch(function () {});
    });

    // Покупатель обнуляет все боксы — скрытое поле видео тоже 0: «Check out» уберёт видео
    // вместе с боксами одним запросом.
    document.addEventListener('input', function (e) {
      var t = e.target;
      var m = meta();
      if (!m || !t.matches || !t.matches('[data-line-key]')) return;
      var total = 0;
      (m.dataset.boxes || '').split(' ').forEach(function (k) {
        if (!k) return;
        var q = document.querySelector('input[data-line-key="' + k + '"]');
        total += q ? Math.max(0, parseInt(q.value, 10) || 0) : 0;
      });
      document.querySelectorAll('[data-video-qty][data-keep]').forEach(function (h) {
        h.value = total > 0 ? 1 : 0;
      });
    });

    document.addEventListener('lunea:cart-rendered', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
